import { render, staticRenderFns } from "./ResponseSummary.vue?vue&type=template&id=195f1306&scoped=true&"
import script from "./ResponseSummary.vue?vue&type=script&lang=js&"
export * from "./ResponseSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResponseSummary.vue?vue&type=style&index=0&id=195f1306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f1306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
